export * from "-!../../../../../node_modules/babel-loader/lib/index.js??ref--0-0!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sidebar.vue?vue&type=template&id=9c6c151c&"


//////////////////
// WEBPACK FOOTER
// ./src/js/module/layout/_source/sidebar.vue?vue&type=template&id=9c6c151c&
// module id = 330
// module chunks = 30